const urls = {
  default: 'http://localhost:8000/rest/v1/',
  local: 'http://localhost:8000/rest/v1/',
  staging: 'https://zubale-zombie-stag.zubale.com/rest/v1/',
  production: 'https://zubale-zombie-prod.zubale.com/rest/v1/',
};

const liveTrackingUrls = {
  default: 'https://tracking-stag.zubale.com/',
  local: 'https://tracking-stag.zubale.com/',
  staging: 'https://tracking-stag.zubale.com/',
  production: 'https://tracking.zubale.com/',
};

const env = window.__RUNTIME_CONFIG__.REACT_APP_SERVER_ENV
  ? window.__RUNTIME_CONFIG__.REACT_APP_SERVER_ENV
  : 'default';

// export const apiUrl = urls[env];
// export const liveTrackingUrl = liveTrackingUrls[env];

export const apiUrl = window.__RUNTIME_CONFIG__.REACT_APP_ZOMBIE_API_URL;
export const liveTrackingUrl =
  window.__RUNTIME_CONFIG__.REACT_APP_LIVE_TRACKING_URL;

// export const DATA_EXPIRE = 7200000; //2 hours
export const DATA_EXPIRE = 10 * 60 * 1000; // 10 min
// export const DATA_EXPIRE = 5000; // 5 sec

export const SUPERSET_DOMAIN = 'https://superset.zubale.com';
export const CLOUD_FUNCTION_URL =
  'https://us-central1-kubernetescluster-265514.cloudfunctions.net';
export const SUPERSET_AUTHENTICATION = `${CLOUD_FUNCTION_URL}/supersetAuthentication`;
